import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { formatTime, getColorById } from "../lib/utils";
import { cn } from "../lib/utils";
import { Trash2 } from "lucide-react";
import { BACKEND_URL } from "../lib/api";

const DeleteShiftConfirmDialog = ({
  open,
  onOpenChange,
  shift,
  employee,
  onConfirm,
}) => {
  if (!shift || !employee) return null;

  const color = getColorById(employee.color);

  const handleConfirm = () => {
    onConfirm?.(shift);
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="delete-shift-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-destructive">
            <Trash2 className="w-5 h-5" />
            Delete Shift
          </AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this shift? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        {/* Shift Info */}
        <div className="p-3 rounded-lg bg-muted/50 my-2">
          <div className="flex items-center gap-3">
            <div 
              className={cn(
                "w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold flex-shrink-0",
                color.bg,
                color.text
              )}
            >
              {employee.avatar_url ? (
                <img 
                  src={employee.avatar_url.startsWith('http') ? employee.avatar_url : `${BACKEND_URL}${employee.avatar_url}`}
                  alt={employee.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
              ) : (
                employee.name?.charAt(0)?.toUpperCase()
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-medium">{employee.name}</p>
              <p className="text-sm text-muted-foreground tabular-nums">
                {formatTime(shift.start_time)} - {formatTime(shift.end_time)}
              </p>
              {shift.breaks?.length > 0 && (
                <p className="text-xs text-muted-foreground">
                  {shift.breaks.length} break(s) included
                </p>
              )}
            </div>
          </div>
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            data-testid="delete-shift-confirm-btn"
          >
            Delete Shift
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteShiftConfirmDialog;
